import { classNames } from 'libs/growth-platform-brand-system-v2/src/utils/style';

const findHero = (data: any) => {
  return data?.hero?.[0]?.publicityMode && 'publicity';
};

export function getGlobalClassNames(
  data: any,
  locale: string,
  additionalClassNames?: string | undefined,
) {
  const publicityMode = findHero(data);

  const newClassNames = classNames(
    'website_v2',
    additionalClassNames,
    locale,
    data?.slug,
    publicityMode,
    data?.activeSpecialBackground && 'specialBackground',
  );

  return newClassNames;
}
